
import { defineComponent } from "vue";

export default defineComponent({
    name: "FooterComponent",
    methods: {
        clearDisplayMode() {
            localStorage.removeItem("search_display_mode");
        }
    }
});
